'use client';

import { useEffect } from 'react';
import { useSatelliteWebRenterConversationHandler_getMessages } from '@zg-rentals/ts-satellite-client-react-query';

import { useInboxConfig } from '../InboxProvider';

export const MESSAGES_QUERY_TAG = 'messages';

type UseMessagesOptions = {
  conversationId: string | undefined;
};

export function useMessages({ conversationId }: UseMessagesOptions) {
  const { httpClient, onUnauthorized } = useInboxConfig();
  const query = useSatelliteWebRenterConversationHandler_getMessages(
    { conversationId: conversationId ?? '' },
    {
      httpClient,
      enabled: Boolean(conversationId),
      meta: {
        tags: [MESSAGES_QUERY_TAG],
        context: { api: 'satellite-api', details: 'getMessages' },
      },
      staleTime: 2_000,
      gcTime: typeof window === 'undefined' ? Infinity : 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
    },
  );

  useEffect(() => {
    const error = query.error;
    if (
      error instanceof Error &&
      error.name === 'DatarouterError' &&
      'responseStatus' in error &&
      error.responseStatus === 401
    ) {
      onUnauthorized();
    }
  }, [onUnauthorized, query.error]);

  return query;
}
